<svg version="1.1" id="Layer_1"
        xmlns="http://www.w3.org/2000/svg" xmlns:xlink="http://www.w3.org/1999/xlink"
        x="0px" y="0px"
        width="18px" height="18px" viewBox="0 0 18 18" enable-background="new 0 0 18 18"
        xml:space="preserve">
        <path d="M14.574,3.922H3.911c-0.84,0-1.523,0.684-1.523,1.523v7.109c0,0.84,0.684,1.523,1.523,1.523h10.664c0.84,0,1.523-0.684,1.523-1.523V5.445C16.098,4.605,15.414,3.922,14.574,3.922M15.082,12.555c0,0.28-0.227,0.508-0.508,0.508H3.911c-0.28,0-0.508-0.228-0.508-0.508V8.111h11.679V12.555z M15.082,7.096H3.403v-1.65c0-0.28,0.228-0.508,0.508-0.508h10.664c0.281,0,0.508,0.228,0.508,0.508V7.096z" />
</svg>
